import React from 'react'
import ExplanationComp from '../../components/explanation';
import EventsLinksOne from '../../components/eventsLinksOne';
import Link from 'gatsby-link'
import Typography from '@material-ui/core/Typography'
import SucesosSubSections from '../../components/sucesosSubSections'
import {
  revolucionSurgimientoExterno,
  revolucionSurgimientoEconomia,
  revolucionSurgimientoSociedad,
  revolucionSurgimientoCultura,
} from '../../assets/sucesosInfo/partOne1776-1820'

const RevolucionSecondPage = () => (
  <div style={{marginTop: 10}} >
    <Typography variant="title" style={{color: '#3A3380', fontWeight: 'bold', fontSize: '1.2rem'}}>
      1776 - 1820: La revolución y el surgimiento de la Patria Criolla | <Link to={'/sucesos/revolucion-surgimiento-patria-criolla'}
            style={{color: '#615b99', borderBottom: '2px dashed'}}>Sección 1</Link> - Sección 2
    </Typography>
    <SucesosSubSections info={revolucionSurgimientoExterno} />
    <SucesosSubSections info={revolucionSurgimientoEconomia} />
    <SucesosSubSections info={revolucionSurgimientoSociedad} />
    <SucesosSubSections info={revolucionSurgimientoCultura} />
  </div>
)

export default RevolucionSecondPage


// WEBPACK FOOTER //
// ./src/pages/sucesos/revolucion-surgimiento-patria-criolla-2.js